// eslint-disable-next-line import/no-cycle
import store from '../store';

function commitMutation(module, method, value) {
  store.commit(`${module}/${method}`, value);
}

async function dispatchAction(module, method, value) {
  return store.dispatch(`${module}/${method}`, value);
}

function getState(module) {
  if (!module) {
    return store.state;
  }
  return store.state[module];
}

function getGetters(module, method) {
  return store.getters[`${module}/${method}`];
}

export default {
  commitMutation,
  dispatchAction,
  getState,
  getGetters,
};
